import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { HydropowerHero } from '../components/hydropower/HydropowerHero';
export function HydropowerPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2541">
      <Navigation data-id="element-2542" />
      <main data-id="element-2543">
        <HydropowerHero data-id="element-2544" />
      </main>
      <Footer data-id="element-2545" />
    </div>;
}